<template>
	<el-container>
		<el-scrollbar>
			<el-header class="header-top" style="height: 50px;"><s-header-top></s-header-top></el-header>
			<el-header class="header"><s-header></s-header></el-header>
			<el-main>
				<div class="content">
					<el-row type="flex" justify="space-between">
						<el-col :span="12">
							<el-breadcrumb separator-class="el-icon-arrow-right">
								<span style="float: left;">当前位置：</span>
								<el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
								<el-breadcrumb-item :to="{ path: '/supporter' }">载体平台</el-breadcrumb-item>
							</el-breadcrumb>
						</el-col>
						<el-col :span="6">
							<el-input placeholder="输入关键字" v-model="title" @change="getPlatformList"><el-button slot="append" icon="el-icon-search"></el-button></el-input>
						</el-col>
					</el-row>

					<el-row class="page">
						<el-col :span="24" class="table">
							<div class="lists">
								<div class="list" v-for="(item, index) in platformList" :key="index">
									<div class="list_content" @click="goDetail(item)">
										<el-image class="img" :src="item.image ? imgPath(item.image) : require('../../static/p.jpg')" fit="contain"></el-image>
										<div class="info">
											<div class="name">{{ item.name }}</div>
											<div class="address">地址：{{ item.address }}{{ item.address }}</div>
											<div class="tags">
												<template v-if="item.keywords&&item.keywords!= ''">
												<el-tag v-for="tag in (item.keywords || '').split(',')" :key="tag" class="tag" type="info" effect="plain" size="small">
													{{ tag }}
												</el-tag>
												</template>
											</div>
										</div>
									</div>
								</div>
							</div>
							<pagination v-show="pageTotal>0" :total="pageTotal" :page.sync="currentPage" :limit.sync="pageSize" @pagination="getPlatformList" />
						</el-col>
					</el-row>
				</div>
			</el-main>
			<el-footer class="footer"><s-footer></s-footer></el-footer>
			<el-footer class="copy-right"><s-copyRight></s-copyRight></el-footer>
		</el-scrollbar>
	</el-container>
</template>

<script>
import sHeaderTop from '@/components/header_top';
import sHeader from '@/components/header';
import sFooter from '@/components/footer';
import sCopyRight from '@/components/copy-right';
import Pagination from '@/components/Pagination';
import { platformList } from '@/api';
export default {
	name: 'index',
	components: {
		sHeaderTop,
		sHeader,
		sFooter,
		sCopyRight,
		Pagination
	},
	data() {
		return {
			title: '',
			// 当前页数
			currentPage: 1,
			// 每页默认显示条数
			pageSize: 10,
			// 总条数
			pageTotal: 0,

			platformList: []
		};
	},
	mounted() {
		if (this.$route.query.keyWord) {
			this.title = this.$route.query.keyWord;
		}
		this.getPlatformList();
	},
	methods: {
		//获取政策列表
		getPlatformList() {
			let _this = this;
			platformList({
				pageNo: _this.currentPage,
				pageSize: _this.pageSize,
				title: _this.title,
			}).then(res => {
				_this.platformList = res.data.list;
				_this.pageTotal = res.data.count;
			});
		},
		//图片地址
		imgPath(oldPath) {
			return this.$imgBaseUrl + oldPath;
		},
		//跳转至平台详情
		goDetail(item) {
			let routeUrl = this.$router.resolve({
				path: '/supporterDetail', //跳转的路径
				query: {
					//路由传参时push和query搭配使用 ，作用时传递参数
					id: item.id
				}
			});
			window.open(routeUrl.href, '_blank');
		}
	}
};
</script>

<style lang="scss" scoped>
.page {
	min-height: 618px; /*若没有tabs56  height524 若有height468 */
}
.type .el-radio-group {
	display: flex;
	flex-direction: column;
}
.type .el-radio {
	margin-left: 0 !important;
	margin-right: 0 !important;
	margin-bottom: 10px;
}
.table {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-left: 20px;
	padding-right: 20px;
	margin-bottom: 20px;
}
.lists {
	width: 100%;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
}
.list {
	width: 200px;
	border: 1px solid #cccccc;
	margin-left: 12px;
	margin-right: 12px;
	margin-bottom: 30px;
	position: relative;
}
.list_content {
	cursor: pointer;
}

.info {
	margin-left: 10px;
	margin-right: 10px;
}
.img {
	height: 150px;
	width: 178px;
	margin: 10px;
}
.name {
	height: 26px;
	line-height: 26px;
	font-weight: bold;
	height: 24px;
	color: rgba(16, 16, 16, 100);
	font-size: 16px;
	text-overflow: -o-ellipsis-lastline;
	letter-spacing: 1px;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
}
.address {
	line-height: 25px;
	height: 50px;
	color: rgba(153, 153, 153, 100);
	font-size: 14px;
	text-overflow: -o-ellipsis-lastline;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	width: 100%;
}
.tags {
	height: 52px;
	overflow: hidden;
	.tag {
		margin-bottom: 2px;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/supporter.vue